/* Product delivery uses Shopify's presentment-currency quote. With an empty
 * bag, a separate anonymous Storefront cart quotes this product; it never
 * changes the customer's cookie cart, address, discounts or checkout. */
(function () {
  'use strict';
  var sequence = 0, timer = null, requestKey = '', settledMessage = '', quoteStatus = 'idle';
  var retryTimer = null, retryKey = '', retryAttempts = 0;
  var diagnostics = {status:'idle', reason:null};
  var productQuoteGeneration = 0, productQuoteEntry = null;
  var PRODUCT_QUOTE_TTL_MS = 60000, PRODUCT_QUOTE_TIMEOUT_MS = 12000;
  var createQuery = 'mutation QuoteCart($input: CartInput!, $country: CountryCode!) @inContext(country: $country) { cartCreate(input: $input) { cart { id } userErrors { message } } }';
  var rateQuery = 'query QuoteRates($id: ID!) { cart(id: $id) { id ...Rates @defer } } fragment Rates on Cart { deliveryGroups(first: 5, withCarrierRates: true) { nodes { deliveryOptions { title description estimatedCost { amount currencyCode } } } } }';
  var productQuery = 'query QuoteProduct($country: CountryCode!) @inContext(country: $country) { products(first: 5, sortKey: PRICE, query: "available_for_sale:true") { nodes { variants(first: 20) { nodes { id availableForSale requiresShipping } } } } }';
  function write(message) {
    // The UK product row belongs to the verified arrival calendar. Rate
    // updates must never replace its date with the basket's delivery charge.
    if (productContext() && productContext().country === 'GB') return;
    // Core owns the persistent PDP date row. These Shopify rates still feed
    // the market banner and bag, without replacing dates during size changes.
    if (!window.dsrcvDeliveryPromiseConfig || window.dsrcvDeliveryPromiseConfig.mode !== 'core') {
      document.querySelectorAll('[data-pdp-free-delivery-copy]').forEach(function (copy) {
        if (copy.textContent !== message) copy.textContent = message;
        var row = copy.closest('[data-pdp-free-delivery-message]');
        if (row) row.hidden = !message || message === 'Checking delivery…';
      });
    }
    document.dispatchEvent(new CustomEvent('dsrcv:product-delivery-updated'));
  }
  function productContext() {
    var product = document.querySelector('[data-pdp-delivery-product]');
    var shopify = window.Shopify || {};
    // The GBP banner already has the canonical free-delivery threshold. Other
    // markets need Shopify's conversion even before a shopper opens a product.
    if (!product && (!shopify.currency || shopify.currency.active === 'GBP')) return null;
    var section = product && product.closest('.shopify-section') || document;
    var form = section.querySelector('form.ProductForm');
    var variant = form && form.querySelector('[name="id"]');
    var quantity = form && form.querySelector('[name="quantity"]');
    return { country: String(shopify.country || '').toUpperCase(),
      currency: String(shopify.currency && shopify.currency.active || '').toUpperCase(),
      variant: product ? String(variant && variant.value || product.dataset.variant || '') : '',
      baseline: !product,
      quantity: product ? Math.max(1, Number(quantity && quantity.value) || 1) : 1 };
  }
  function money(rate) {
    if (!rate || !Number.isSafeInteger(rate.priceCents) || rate.priceCents < 0) throw new Error('invalid_rate');
    return rate.priceCents === 0 ? 'Free delivery' : 'Delivery ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: rate.currency
    }).format(rate.priceCents / 100);
  }
  function ratesMessage(rates) {
    if (!rates.length) throw new Error('no_rates');
    var lowest = rates.reduce(function (a, b) { return a.priceCents <= b.priceCents ? a : b; });
    return rates.length === 1 ? money(lowest) : 'Delivery from ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: lowest.currency
    }).format(lowest.priceCents / 100);
  }
  function currentMessage() {
    if (productContext() && productContext().country === 'GB') return '';
    var api = window.dsrcvCartShipping;
    if (!api) return '';
    var state = api.getState(), shopify = window.Shopify || {};
    if (state.status === 'pending') return 'Checking delivery…';
    if (state.cartItemCount === 0) return requestKey === JSON.stringify(productContext()) ? settledMessage : '';
    var rates = state.rate ? [state.rate] : state.rates || [];
    rates = rates.filter(function (rate) { return rate.countryCode === shopify.country && rate.currency === (shopify.currency || {}).active; });
    try { return ratesMessage(rates); } catch (error) { return ''; }
  }
  function cancel() {
    ++sequence;
    window.clearTimeout(retryTimer); retryTimer = null;
    requestKey = ''; settledMessage = ''; quoteStatus = 'idle';
  }
  function report(status, reason, context) {
    diagnostics = {status:status, reason:reason || null, country:context.country, currency:context.currency};
  }
  function optionsContext(context) {
    return {
      country: context && context.country || '',
      currency: context && context.currency || '',
      variant: context && !context.baseline ? context.variant : '',
      quantity: context && !context.baseline && Number.isSafeInteger(context.quantity) ? context.quantity : 0
    };
  }
  function unavailableOptions(context, reason, expiresAt) {
    return {status:'unavailable', context:optionsContext(context), rates:[], expiresAt:expiresAt || 0, reason:reason || 'quote_unavailable'};
  }
  function copyOptions(result) {
    return {
      status:result.status,
      context:Object.assign({}, result.context),
      rates:result.rates.map(function (rate) {
        var copy = {title:rate.title, priceCents:rate.priceCents, currency:rate.currency};
        if (rate.description) copy.description = rate.description;
        return copy;
      }),
      expiresAt:result.expiresAt,
      reason:result.reason
    };
  }
  function contextKey(context) { return JSON.stringify(context || null); }
  function synchronizeProductQuote(context) {
    var key = contextKey(context);
    if (productQuoteEntry && productQuoteEntry.key !== key) {
      productQuoteGeneration += 1;
      if (productQuoteEntry.controller) productQuoteEntry.controller.abort();
      productQuoteEntry = null;
    }
  }
  function invalidateProductQuote() {
    if (!productQuoteEntry) return;
    productQuoteGeneration += 1;
    if (productQuoteEntry.controller) productQuoteEntry.controller.abort();
    productQuoteEntry = null;
  }
  function productQuoteIsCurrent(entry, context) {
    return productQuoteEntry === entry && entry.generation === productQuoteGeneration &&
      entry.key === contextKey(productContext()) && entry.key === contextKey(context);
  }
  function requestProductRates(context, entry) {
    async function request(query, variables, multipart) {
      var response;
      try {
        response = await fetch('/api/2026-07/graphql.json', { method: 'POST', credentials: 'omit', cache: 'no-store',
          headers: {'Content-Type': 'application/json', Accept: multipart ? 'multipart/mixed; boundary="graphql", application/json' : 'application/json'},
          body: JSON.stringify({query: query, variables: variables}), signal: entry.controller.signal });
      } catch (error) {
        if (error instanceof TypeError) throw new Error('network_error');
        throw error;
      }
      if (!response.ok) throw new Error('quote_http_' + response.status);
      return response;
    }
    async function read(response, method) {
      if (!response || typeof response[method] !== 'function') throw new Error('invalid_response');
      try { return await response[method](); }
      catch (error) {
        if (error instanceof TypeError) throw new Error('network_error');
        throw error;
      }
    }
    return (async function () {
      var merchandiseId = 'gid://shopify/ProductVariant/' + context.variant;
      if (context.baseline) {
        var catalogue = await read(await request(productQuery, {country: context.country}), 'json');
        var candidates = catalogue.data && catalogue.data.products && catalogue.data.products.nodes || [];
        var available = null;
        candidates.some(function (product) {
          available = (product.variants.nodes || []).find(function (variant) { return variant.availableForSale && variant.requiresShipping; });
          return !!available;
        });
        if (catalogue.errors || !available || !available.id) throw new Error('quote_product_unavailable');
        merchandiseId = available.id;
      }
      if (!productQuoteIsCurrent(entry, context)) throw new Error('stale_context');
      var api = window.dsrcvCartShipping;
      if (!api || typeof api.destinationFor !== 'function') throw new Error('shipping_adapter_unavailable');
      var sample = api.destinationFor(context.country);
      var created = await read(await request(createQuery, {country: context.country, input: {
        buyerIdentity: {countryCode: context.country},
        lines: [{merchandiseId: merchandiseId, quantity: context.quantity}],
        delivery: {addresses: [{selected: true, oneTimeUse: true, address: {deliveryAddress: {
          countryCode: context.country, provinceCode: sample.province, zip: sample.zip
        }}}]}
      }}), 'json');
      var payload = created.data && created.data.cartCreate;
      if (created.errors || !payload) throw new Error('cart_create_failed');
      if (!Array.isArray(payload.userErrors)) throw new Error('invalid_response');
      if (payload.userErrors.length || !payload.cart || !payload.cart.id) throw new Error('cart_create_failed');
      if (!productQuoteIsCurrent(entry, context)) throw new Error('stale_context');
      var response = await request(rateQuery, {id: payload.cart.id}, true);
      var rates = deliveryRates(await read(response, 'text'), response.headers.get('Content-Type') || '', context.currency);
      if (!rates.length) throw new Error('no_rates');
      return rates;
    }());
  }
  function ensureProductOptions(context, allowBaseline, force, optionRequest) {
    if (!context || (context.baseline && !allowBaseline)) return Promise.resolve(unavailableOptions(context, 'no_product'));
    synchronizeProductQuote(context);
    if (!/^[A-Z]{2}$/.test(context.country) || !/^[A-Z]{3}$/.test(context.currency) ||
        (!context.baseline && !/^\d+$/.test(context.variant)) || !Number.isSafeInteger(context.quantity) || context.quantity < 1) {
      return Promise.resolve(unavailableOptions(context, 'invalid_context'));
    }
    var key = contextKey(context), existing = productQuoteEntry;
    if (existing && existing.key === key) {
      if (existing.pending) {
        if (optionRequest) existing.optionsRequested = true;
        return existing.promise;
      }
      if (!force && Date.now() < existing.expiresAt) return Promise.resolve(existing.result);
    }
    var entry = {key:key, generation:++productQuoteGeneration, controller:new AbortController(), pending:true,
      promise:null, result:null, expiresAt:0, optionsRequested:optionRequest === true};
    productQuoteEntry = entry;
    var timeoutId;
    var deadline = new Promise(function (_, reject) {
      timeoutId = window.setTimeout(function () {
        var error = new Error('timeout');
        entry.controller.abort();
        reject(error);
      }, PRODUCT_QUOTE_TIMEOUT_MS);
    });
    entry.promise = Promise.race([requestProductRates(context, entry), deadline]).then(function (rates) {
      if (!productQuoteIsCurrent(entry, context)) return unavailableOptions(context, 'stale_context');
      var expiresAt = Date.now() + PRODUCT_QUOTE_TTL_MS;
      var result = {status:'available', context:optionsContext(context), rates:rates, expiresAt:expiresAt, reason:null};
      entry.result = result; entry.expiresAt = expiresAt;
      return result;
    }).catch(function (error) {
      if (!productQuoteIsCurrent(entry, context)) return unavailableOptions(context, 'stale_context');
      var reason = error && error.message || 'quote_unavailable';
      if (error && error.name === 'AbortError') reason = 'timeout';
      else if (error instanceof SyntaxError || error instanceof TypeError) reason = 'invalid_response';
      var expiresAt = Date.now() + PRODUCT_QUOTE_TTL_MS;
      var result = unavailableOptions(context, reason, expiresAt);
      entry.result = result; entry.expiresAt = expiresAt;
      return result;
    }).finally(function () {
      window.clearTimeout(timeoutId);
      entry.pending = false;
    });
    return entry.promise;
  }
  function getOptions() {
    var context = productContext();
    synchronizeProductQuote(context);
    if (!context || context.baseline) return Promise.resolve(unavailableOptions(context, 'no_product'));
    return ensureProductOptions(context, false, false, true).then(copyOptions);
  }
  // Shopify carrier rates arrive as a deferred multipart response. Read every
  // part only after the bounded request completes; reject partial/error replies.
  function deliveryRates(text, contentType, currency) {
    var parts;
    if (/multipart\/mixed/i.test(contentType)) {
      var boundary = /boundary="?([^";\s]+)/i.exec(contentType);
      if (!boundary) throw new Error('invalid_response');
      parts = text.split('--' + boundary[1]).filter(function (part) { return /\r?\n\r?\n/.test(part); }).map(function (part) {
        return JSON.parse(part.split(/\r?\n\r?\n/).slice(1).join('\n\n').trim());
      });
    } else parts = [JSON.parse(text)];
    if (!parts.length || parts[parts.length - 1].hasNext === true) throw new Error('incomplete_response');
    var groups = null;
    parts.forEach(function (part) {
      if (part.errors && part.errors.length) throw new Error('quote_failed');
      if (part.data && part.data.cart && part.data.cart.deliveryGroups) groups = part.data.cart.deliveryGroups.nodes;
      (part.incremental || []).forEach(function (patch) {
        if (patch.errors && patch.errors.length) throw new Error('quote_failed');
        if (JSON.stringify(patch.path) === '["cart"]' && patch.data && patch.data.deliveryGroups) groups = patch.data.deliveryGroups.nodes;
      });
    });
    // Multiple shipping groups can require summed rates. Do not imply the
    // cheapest individual shipment is the total delivery price.
    if (!Array.isArray(groups) || groups.length !== 1) throw new Error('unsupported_groups');
    return (groups[0].deliveryOptions || []).map(function (option) {
      var cost = option.estimatedCost || {}, amount = String(cost.amount);
      var numericAmount = Number(amount), cents = Math.round(numericAmount * 100);
      if (cost.currencyCode !== currency) throw new Error('currency_mismatch');
      if (!/^\d+(?:\.\d+)?$/.test(amount) || !Number.isFinite(numericAmount) || !Number.isSafeInteger(cents) ||
          cents < 0 || Math.abs(numericAmount * 100 - cents) > 0.000001) throw new Error('invalid_rate');
      var result = {title:typeof option.title === 'string' ? option.title.trim() : '', priceCents:cents, currency:currency};
      var description = typeof option.description === 'string' ? option.description.trim() : '';
      if (description) result.description = description;
      return result;
    });
  }
  async function quoteProduct(context, api, force) {
    var key = JSON.stringify(context);
    if (requestKey === key) { write(quoteStatus === 'pending' ? 'Checking delivery…' : settledMessage); return; }
    if (retryKey !== key) { retryKey = key; retryAttempts = 0; }
    cancel(); requestKey = key;
    quoteStatus = 'pending'; report('pending', null, context);
    var current = sequence;
    write('Checking delivery…');
    var result = await ensureProductOptions(context, true, force === true);
    if (current !== sequence || key !== JSON.stringify(productContext()) || api.getState().cartItemCount !== 0) return;
    if (result.status === 'available') {
      var rates = result.rates;
      var message = ratesMessage(rates);
      if (context.baseline) message = 'Delivery from ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: context.currency
      }).format(Math.min.apply(null, rates.map(function (rate) { return rate.priceCents; })) / 100);
      quoteStatus = 'available'; settledMessage = message; report('available', null, context); write(message);
      return;
    }
    var reason = result.reason || 'quote_unavailable';
    quoteStatus = 'unavailable'; settledMessage = ''; report('unavailable', reason, context); write('');
    if (retryAttempts < 1 && /^(?:timeout|network_error|quote_http_429|quote_http_5\d\d)$/.test(reason)) {
      retryAttempts++;
      retryTimer = window.setTimeout(function () {
        retryTimer = null;
        if (current !== sequence || key !== JSON.stringify(productContext()) || api.getState().cartItemCount !== 0) return;
        requestKey = '';
        quoteProduct(context, api, true);
      }, 1500);
    }
  }
  function update() {
    var context = productContext(), api = window.dsrcvCartShipping;
    synchronizeProductQuote(context);
    if (!context || !api) return;
    if (context.country === 'GB') {
      cancel(); report('calendar', null, context); return;
    }
    var state = api.getState();
    if (state.cartItemCount === 0 && state.status !== 'pending') { quoteProduct(context, api); return; }
    // Keep the legacy empty-bag banner quote cancellable when the customer's
    // basket changes, while an explicitly requested PDP options quote remains
    // independent of the cookie-cart state.
    if ((state.status === 'pending' || state.cartItemCount > 0) && productQuoteEntry &&
        productQuoteEntry.key === contextKey(context) && productQuoteEntry.pending && !productQuoteEntry.optionsRequested) {
      invalidateProductQuote();
    }
    cancel();
    if (state.cartItemCount > 0) { retryKey = ''; retryAttempts = 0; }
    var rates = state.rate ? [state.rate] : state.rates || [];
    rates = rates.filter(function (rate) { return rate.countryCode === context.country && rate.currency === context.currency; });
    try { report('available', null, context); write(ratesMessage(rates)); }
    catch (error) {
      report(state.status === 'pending' ? 'pending' : 'unavailable', state.status === 'pending' ? null : state.status, context);
      write(state.status === 'pending' ? 'Checking delivery…' : '');
    }
  }
  function schedule() { window.clearTimeout(timer); timer = window.setTimeout(update, 50); }
  document.addEventListener('dsrcv:cart-shipping-updated', schedule);
  document.addEventListener('change', function (event) {
    if (event.target.matches('form.ProductForm [name="id"], form.ProductForm [name="quantity"]')) schedule();
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('form.ProductForm [data-action="increase-quantity"], form.ProductForm [data-action="decrease-quantity"]')) schedule();
  });
  window.dsrcvProductDelivery = {getMessage: currentMessage, getStatus: function () { return Object.assign({}, diagnostics); }, getOptions:getOptions};
  ['ajax-product:loaded', 'variant:change', 'variant:changed', 'product:variant-change', 'currency:change', 'covCurrency:updated'].forEach(function (event) { document.addEventListener(event, schedule); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
})();
